import React from "react";
import { moment, renderNumberGreaterThan100 } from "../common/common";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";

import { stypes, getWdType } from "../common/common";

import { IcCalendarSearch, IcStarRating, IcTotalTrip } from "../common/svg";

const viewMode = {
	TRIPS: 0,
	HISTORY: 1,
	CS: 2,
};

const CarItemMyTrips = ({ car, trip, isSD, mode }) => {
	return (
		<div className="item-car row">
			<div className="item-box">
				<div className="img-car">
					{/* {mode === viewMode.CS ? 
						<div className="fix-img">
							<img
								loading="lazy"
								src={`${car.photos ? car.photos[0].thumbUrl : ""}`}
								alt={`Cho thuê xe tự lái ${car.name}`}
							/>
						</div>
					:  */}
					<a href={`/trip/detail/${trip.id}`} target="_blank">
						<div className="fix-img">
							<img
								loading="lazy"
								src={`${car.photos ? car.photos[0].thumbUrl : ""}`}
								alt={`Cho thuê xe tự lái ${car.name}`}
							/>
						</div>
					</a>
				</div>
				<div className="desc-car">
					<div className="desc-tag">
						<span className="tag-item transmission">{isSD ? "Tự lái" : `${getWdType[trip.wd?.wdType]}`}</span>
						{trip.b2b ? <span className="tag-item delivery">Doanh nghiệp</span> : null}
					</div>
					<div className="desc-name">
						<p>{car.name}</p>
					</div>
					<div className="desc-info">
						{car.totalTrips > 0 ? (
							<>
								<div className="wrap-svg">
									<IcStarRating />
								</div>
								<span className="info">{car.rating.avg.toFixed(1)}</span>
								<span className="dot">•</span>
								<div className="wrap-svg">
									<IcTotalTrip />
								</div>
								<span className="info">{renderNumberGreaterThan100(car.totalTrips)} chuyến</span>
							</>
						) : (
							<>
								<span className="info">Chưa có chuyến</span>
							</>
						)}
					</div>
					<div className="desc-trip">
						<div className="desc-trip__item">
							<div className="wrap-svg">
								<IcCalendarSearch />
							</div>
							<p>
								Bắt đầu:{" "}
								{mode === viewMode.CS
									? moment(trip.tripDateFrom).format("dddd, DD/MM/YYYY")
									: moment(trip.tripDateFrom).format("HH:mm - dddd, DD/MM/YYYY")}
							</p>
						</div>
						<div className="desc-trip__item">
							<div className="wrap-svg">
								<IcCalendarSearch />
							</div>
							<p>
								Kết thúc:{" "}
								{mode === viewMode.CS
									? moment(trip.tripDateTo).format("dddd, DD/MM/YYYY")
									: moment(trip.tripDateTo).format("HH:mm - dddd, DD/MM/YYYY")}
							</p>
						</div>
						{mode === viewMode.CS && trip.priceSummary && (
							<div className="desc-trip__item">
								<p>Thời gian thuê: {trip.priceSummary.totalMonths} tháng</p>
							</div>
						)}
					</div>
					<div className="desc-name">
						<p>
							Tổng tiền:{" "}
							<NumberFormat
								value={trip.serviceType === stypes.WD ? trip.wd.priceSummary.finalPrice : trip.priceSummary.priceTotal}
								displayType={"text"}
								thousandSeparator={" "}
								decimalSeparator={","}
								suffix="đ"
							/>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CarItemMyTrips;
